__turbopack_context__.v({
  "error": "kBizRG_error",
  "errorEBBHomePage": "kBizRG_errorEBBHomePage",
  "eye-icon": "kBizRG_eye-icon",
  "input-group": "kBizRG_input-group",
  "msgBlock": "kBizRG_msgBlock",
  "success": "kBizRG_success",
  "textBox": "kBizRG_textBox",
});
